import { render, staticRenderFns } from "./DeviceInfoPanel.vue?vue&type=template&id=22bc30b0&scoped=true&"
import script from "./DeviceInfoPanel.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfoPanel.vue?vue&type=style&index=0&id=22bc30b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc30b0",
  null
  
)

export default component.exports